import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const getAdminPurchaseOrders = createAsyncThunk(
    "/admin/get-admin-pos",
    async (payload = {}, { rejectWithValue }) => {
        try {
            const myurl = `${V_URL}/believe/get-pos`;

            const response = await axios({
                method: "post",
                url: myurl,
                data: payload,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("VA_TOKEN"),
                },
            });

            const data = response.data;
            if (data.success === true) {
                return data;
            } else {
                toast.error(data.message || "Failed to fetch Purchase Orders");
                return rejectWithValue(data);
            }
        } catch (error) {
            const message = error.response?.data?.message || error.message || "Something went wrong";
            toast.error(message);
            return rejectWithValue(error.response?.data || message);
        }
    }
);

const getAdminPurchaseOrdersSlice = createSlice({
    name: "getAdminPurchaseOrders",
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAdminPurchaseOrders.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAdminPurchaseOrders.fulfilled, (state, action) => {
                state.data = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getAdminPurchaseOrders.rejected, (state, action) => {
                state.data = null;
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default getAdminPurchaseOrdersSlice.reducer;
